<template>
<v-container>

    <v-alert dark class="teal darken-2" v-model="geolocating">

      <v-row text-center>
        <p> <v-icon class="mr-2">mdi-crosshairs-gps</v-icon>{{ $t('validation.geolocating') }}</p>
        <v-progress-linear
                   color="white"
                   indeterminate
                   rounded
                   height="6"
                 ></v-progress-linear>
      </v-row>
    </v-alert>
    <v-alert :type="typeAlert" v-model="alertGPS">
       {{ alertText }}
    </v-alert>

<MglMap v-if="center !==null" :center="center"  :style="{
     width: '100%',
     height: '300px',
     }" :zoom="16"   @load="load" :accessToken="accessToken" :mapStyle="mapStyle" >
    <MglNavigationControl />
<MglMarker  :coordinates="center" />
</MglMap>
</v-container>
</template>

<script>
import "mapbox-gl/dist/mapbox-gl.css";
import Vue from 'vue'
import * as turf from '@turf/turf';
//const turf = () => import(/* webpackChunkName: 'turf' */ '@turf/turf')
import { MglMap, MglMarker,MglNavigationControl } from "vue-mapbox";
import GeolocMarker from './geoloc_marker.vue';
const mapboxgl = require(/* webpackChunkName: "mapbox" */'mapbox-gl');
//const mapboxgl = () => import(/* webpackChunkName: 'mapbox' */ 'mapbox-gl')
export default {
  props: ['geolocating','center', 'radius', 'geoloc', 'alertGPS', 'typeAlert', 'alertText'],
  components: {  MglMap, MglMarker,MglNavigationControl },
  data: () => ({
    mapStyle: 'mapbox://styles/mapbox/streets-v11',
    accessToken: 'pk.eyJ1Ijoic2ltb241MSIsImEiOiJjamg4dGUyZXkwNmxuM2NvNmFxN2p5cnpmIn0.G4Igc5WvjFjuIQ6UcuxLOQ',
    geolocMarkerTmp: Vue.extend(GeolocMarker),
    geolocationMarker: null,

   }),

  created() {
      this.map = null;
  },
  watch: {
    geoloc(v) {

        if (v && this.geolocationMarker) {
          this.geolocationMarker.setLngLat([v.longitude, v.latitude])
        }
    }
  },


  methods: {

    load(e) {
        this.map = e.map;
        //console.log(this.center);
         var center = turf.point(this.center);
         let radius = this.radius;
         let o =  {
      steps: 80,
      units: 'meters'
    };
         let circle = turf.circle(center, radius, o);
         this.map.addLayer({
         "id": "circle-fill",
         "type": "fill",
         "source": {
             "type": "geojson",
             "data": circle
         },
         "paint": {
             "fill-color": "pink",
             "fill-opacity": 0.5
         }
     });

     var el = document.createElement('div');
     el.className = 'marker';
     el.innerHTML = '<div class="vue-marker"></div>'

     this.geolocationMarker = new mapboxgl.Marker(el);
     if (this.geoloc) {
        this.geolocationMarker.setLngLat([this.geoloc.longitude, this.geoloc.latitude]).addTo(this.map);

     }  else {
        this.geolocationMarker.setLngLat([0, 0]).addTo(this.map);
     }

     new this.geolocMarkerTmp().$mount('.vue-marker')

   this.map.addLayer({
           "id": "circle-outline",
           "type": "line",
           "source": {
               "type": "geojson",
               "data": circle
           },
           "paint": {
               "line-color": "blue",
               "line-opacity": 0.5,
               "line-width": 5,
               "line-offset": 5
           },
           "layout": {

           }
       });


        setTimeout(() => {
          this.map.resize();
        }, 250);
    }
  }
}

</script>
